import React from "react";
import AppLink from "../components/home/AppLink";
import useBranch from "../hooks/useBranch";
import { S3_ENDPOINT } from "../utils";

const MainLanding = () => {
  const { branches, selectBranch } = useBranch();

  return (
    <div id="main-landing">
      <div className="row align-items-center">
        <AppLink
          title={
            <>
              Train <br />
              Online
            </>
          }
          src={`${S3_ENDPOINT}/tbm-online-landing.jpg`}
          mobile={`${S3_ENDPOINT}/tbm-online-landing.jpg`}
          logo="https://thebodymethod.s3.us-west-1.amazonaws.com/tbm-online-logo.png"
          logoClassName="app-link-logo--sm"
          href="/online"
          purpleEdgeTint
        />
        <AppLink
          title={
            <>
              Book <br />A Class
            </>
          }
          src={`${S3_ENDPOINT}/tbm-presencial-landing.jpg`}
          mobile={`${S3_ENDPOINT}/tbm-presencial-landing.jpg`}
          href="/monterrey"
          handleClick={() => {
            selectBranch(branches[0].branch_id);
          }}
          buttons={[
            {
              label: "TBM Monterrey",
              url: "/monterrey",
              handleClick: () => selectBranch(branches[0]?.branch_id),
            },
            { label: "TBM Tijuana", url: "/tijuana" },
            { label: "TBM Partner Studios", url: "/partners" },
          ]}
        />
        <AppLink
          title={
            <>
              Get <br />
              Certified
            </>
          }
          src={`${S3_ENDPOINT}/tbmcertifications-landing.jpg`}
          href="https://tbmcertifications.com/"
          logo="https://tbmcerts.s3.us-west-1.amazonaws.com/tbmcerts-logo.png"
          changeBaseUrl
          purpleEdgeTint
        />
      </div>
    </div>
  );
};

export default MainLanding;
